
import { addDays, addMonths, format } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react'
import { DateRange } from 'react-date-range'
import { DateRangePickerWrapper } from './style';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
function DateRangePicker({applyDate,defaultDate="current", onClear=()=>{},clearDate=()=>{}, addMonth=0}) {
  const [dateRange, setDateRange] = useState({
    startDate: null, 
    endDate: null,
    key: "selection",
  });
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [hasUserSelected, setHasUserSelected] = useState(false);
  const lastAppliedRef = useRef({ startDate: null, endDate: null });
  const containerRef = useRef(null);
  const wasPickerOpen = useRef(false);
  const isSelectingRange = useRef(false);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowDatePicker(false);
      }
    }
    
    if (showDatePicker) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDatePicker]);

  useEffect(() => {
    if (wasPickerOpen.current && !showDatePicker) {
      const start = dateRange.startDate;
      const end = dateRange.endDate;
      
      if (start && end) {
        if (lastAppliedRef.current.startDate?.getTime() !== start.getTime() || 
            lastAppliedRef.current.endDate?.getTime() !== end.getTime()) {
          lastAppliedRef.current = { startDate: start, endDate: end };
          applyDate(start, end);
        }
      } else if (start && !end && isSelectingRange.current) {
        const nextDay = addDays(start, 1);
        if (lastAppliedRef.current.startDate?.getTime() !== start.getTime() || 
            lastAppliedRef.current.endDate?.getTime() !== nextDay.getTime()) {
          lastAppliedRef.current = { startDate: start, endDate: nextDay };
          setDateRange({
            startDate: start,
            endDate: nextDay,
            key: "selection",
          });
          applyDate(start, nextDay);
        }
        isSelectingRange.current = false;
      }
    }
    wasPickerOpen.current = showDatePicker;
  }, [showDatePicker]);

  useEffect(()=>{
    if(!defaultDate) return
    const today = new Date();
    setDateRange({
      startDate: today,
      endDate: today,
      key: "selection",
    })
    if (!hasUserSelected && (lastAppliedRef.current.startDate === null || 
        lastAppliedRef.current.startDate?.getTime() !== today?.getTime())) {
      lastAppliedRef.current = { startDate: today, endDate: today };
      applyDate(today, today);
    }
  },[defaultDate, hasUserSelected])

  const onApply = () =>{
    setShowDatePicker(false)
    const start = dateRange.startDate;
    const end = dateRange.endDate;
    if (lastAppliedRef.current.startDate?.getTime() !== start?.getTime() || 
        lastAppliedRef.current.endDate?.getTime() !== end?.getTime()) {
      lastAppliedRef.current = { startDate: start, endDate: end };
      applyDate(start, end);
    }
    isSelectingRange.current = false;
  }

  const handleSelect = (ranges) => {
    const startDate = ranges.selection?.startDate;
    const endDate = ranges.selection?.endDate;
    setDateRange({
      startDate,
      endDate,
      key: "selection",
    });

    if (startDate && endDate) {
      if (startDate.getTime() === endDate.getTime() && !isSelectingRange.current) {
        isSelectingRange.current = true;
      } else {
        setShowDatePicker(false);
        setHasUserSelected(true);
        isSelectingRange.current = false;
        if (lastAppliedRef.current.startDate?.getTime() !== startDate.getTime() || 
            lastAppliedRef.current.endDate?.getTime() !== endDate.getTime()) {
          lastAppliedRef.current = { startDate, endDate };
          applyDate(startDate, endDate);
        }
      }
    }
  };

  const onClear_ = () =>{
    setHasUserSelected(false);
    isSelectingRange.current = false;
    if( defaultDate === "current"){
      const today = new Date();
      setDateRange({
        startDate: today,
        endDate: today,
       })
       lastAppliedRef.current = { startDate: today, endDate: today };
       onClear(null, null);
     
    }else{
      setDateRange({
        startDate:"",
        endDate: "",
       })
       lastAppliedRef.current = { startDate: null, endDate: null };
       onClear(null,null);
   
    }
    setShowDatePicker(false)
  }
  clearDate(onClear_);

  const defaultRange = [
    {
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      }
  ]
  return (
    <DateRangePickerWrapper>
      
     <div className="date-picker" onClick={() => setShowDatePicker(!showDatePicker)}>
                📅 <span>{(dateRange?.endDate && dateRange?.startDate)? format(dateRange?.startDate, 'dd MMM yyyy'):"Select Date"}</span> {(dateRange?.endDate && dateRange?.startDate) && "To"} <span>{dateRange?.endDate?format(dateRange?.endDate, 'dd MMM yyyy'):""}</span>
              </div>
              {showDatePicker && (
        <div className="date-range-container" ref={containerRef}>
          <DateRange
            ranges={((dateRange?.endDate || dateRange?.startDate))?[dateRange]:defaultRange}
            onChange={handleSelect}
            maxDate={addMonths(new Date(), addMonth)}
            moveRangeOnFirstSelection={false}
          />
          <div className="flex gap-10 button">
            <button onClick={onApply} className="apply-button">Apply</button>
            <button onClick={onClear_} className="apply-button">Clear</button>
          </div>
        </div>
      )}
    </DateRangePickerWrapper>
  )
}

export default DateRangePicker;
